import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import {keyframes} from '@emotion/core';

const scale = keyframes`
  100% {
    transform: scaleY(0.5);
  }
`;

const animateOpacity = keyframes`
  100% {
    opacity: 0.4;
  }
`;

const Icon = styled.svg`
  .active &,
  .idle & {
    #waveOne {
      animation: ${animateOpacity} 5s cubic-bezier(0.4, 0, 1, 1) infinite
          alternate,
        ${scale} 5s cubic-bezier(0.4, 0, 1, 1) infinite alternate;
    }
    #waveTwo {
      animation: ${animateOpacity} 4s 1s cubic-bezier(0.4, 0, 1, 1) infinite
          alternate,
        ${scale} 5s 1s cubic-bezier(0.4, 0, 1, 1) infinite alternate;
    }
  }
  .cls-1,
  .cls-2 {
    fill: #fff;
    fill-rule: evenodd;
    transform-origin: bottom;
  }
  .cls-2 {
    fill-opacity: ${({active}) => (active ? 1 : 0.4)};
  }
  .cls-3 {
    fill: none;
    stroke: #fff;
    stroke-miterlimit: 10;
  }
  .hidden {
    visibility: hidden;
  }
`;
export const WellsIcon = ({active}) => {
  return (
    <Icon viewBox='0 0 71 71'>
      <g id='wells_icon' data-name='wells icon'>
        <path
          className='cls-1'
          d='M.5.5v10h70V.5Zm44,1a1,1,0,1,1-1,1A1,1,0,0,1,44.5,1.5Zm-16,0a1,1,0,1,1-1,1A1,1,0,0,1,28.5,1.5Zm-8,0a1,1,0,1,1-1,1A1,1,0,0,1,20.5,1.5Zm-19,3a1,1,0,1,1,1,1A1,1,0,0,1,1.5,4.5Zm2,5a1,1,0,1,1,1-1A1,1,0,0,1,3.5,9.5Zm2-2a1,1,0,1,1,1-1A1,1,0,0,1,5.5,7.5Zm0-4a1,1,0,1,1,1-1A1,1,0,0,1,5.5,3.5Zm3,6a1,1,0,1,1,1-1A1,1,0,0,1,8.5,9.5Zm1-4a1,1,0,1,1,1-1A1,1,0,0,1,9.5,5.5Zm2,2a1,1,0,1,1,1-1A1,1,0,0,1,11.5,7.5Zm2-4a1,1,0,1,1,1-1A1,1,0,0,1,13.5,3.5Zm3,6a1,1,0,1,1,1-1A1,1,0,0,1,16.5,9.5Zm0-4a1,1,0,1,1,1-1A1,1,0,0,1,16.5,5.5Zm4,2a1,1,0,1,1,1-1A1,1,0,0,1,20.5,7.5Zm2,2a1,1,0,1,1,1-1A1,1,0,0,1,22.5,9.5Zm2-4a1,1,0,1,1,1-1A1,1,0,0,1,24.5,5.5Zm4,2a1,1,0,1,1,1-1A1,1,0,0,1,28.5,7.5Zm2,2a1,1,0,1,1,1-1A1,1,0,0,1,30.5,9.5Zm2-4a1,1,0,1,1,1-1A1,1,0,0,1,32.5,5.5Zm2,2a1,1,0,1,1,1-1A1,1,0,0,1,34.5,7.5Zm1-5a1,1,0,1,1,1,1A1,1,0,0,1,35.5,2.5Zm2,4a1,1,0,1,1,1-1A1,1,0,0,1,37.5,6.5Zm3,2a1,1,0,1,1,1-1A1,1,0,0,1,40.5,8.5Zm0-4a1,1,0,1,1,1-1A1,1,0,0,1,40.5,4.5Zm4,2a1,1,0,1,1,1-1A1,1,0,0,1,44.5,6.5Zm2,2a1,1,0,1,1,1-1A1,1,0,0,1,46.5,8.5Zm1-5a1,1,0,1,1,1,1A1,1,0,0,1,47.5,3.5Zm2,4a1,1,0,1,1,1-1A1,1,0,0,1,49.5,7.5Zm4,0a1,1,0,1,1,1-1A1,1,0,0,1,53.5,7.5Zm0-4a1,1,0,1,1,1-1A1,1,0,0,1,53.5,3.5Zm4,2a1,1,0,1,1,1-1A1,1,0,0,1,57.5,5.5Zm2,2a1,1,0,1,1,1-1A1,1,0,0,1,59.5,7.5Zm1-5a1,1,0,1,1,1,1A1,1,0,0,1,60.5,2.5Zm2,7a1,1,0,1,1,1-1A1,1,0,0,1,62.5,9.5Zm3-2a1,1,0,1,1,1-1A1,1,0,0,1,65.5,7.5Zm0-3a1,1,0,1,1,1-1A1,1,0,0,1,65.5,4.5Z'
        />
        <g className='waves'>
          <path
            className='cls-2'
            id='waveOne'
            d='M70.5,70.5H.5V32.7s1.4-1.4,5.6,0c9.39,3.13,4.2,1.4,16.8,0,10.81-1.2,19.58,2.24,30.8,0,7-1.4,16.8.53,16.8.53Z'
          />
          <path
            className='cls-2'
            id='waveTwo'
            d='M70.5,70.5H.5V34a128.86,128.86,0,0,1,18.2-1.3c9.8,0,12.36,3.18,22.4,0,11.2-3.54,7,2.37,19.6,0,6.17-1.15,9.8.57,9.8.57Z'
          />
        </g>
        <rect className='cls-3' x='0.5' y='0.5' width='70' height='70' />
      </g>
    </Icon>
  );
};

WellsIcon.propTypes = {
  active: PropTypes.bool,
};
